import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth0 } from '@auth0/auth0-react';
import AnalyticsDashboard from './AnalyticsDashboard';

const HeroSection = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const [showVideo, setShowVideo] = useState(false);

  return (
    <section className="relative overflow-hidden bg-gray-900 pt-20 pb-24 md:pt-28 md:pb-32">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-grid-slate-800 [mask-image:linear-gradient(0deg,rgba(255,255,255,0.1),rgba(255,255,255,0.05))] bg-[length:20px_20px]"></div>
      </div>

      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Left content */}
          <div className="w-full lg:w-1/2 mb-12 lg:mb-0 text-center lg:text-left">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold text-white mb-6 leading-tight">
                <span className="inline-block">Transform Your</span>{' '}
                <span className="inline-block relative">
                  Customer Data
                  <svg className="absolute -bottom-2 left-0 w-full h-3 text-red-500" viewBox="0 0 184 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 8C29.3335 3.33333 123.667 -1.66667 182 8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                  </svg>
                </span>
                <br />
                <span className="inline-block text-red-500">Into Actionable Insights</span>
              </h1>
              <motion.p
                className="text-lg md:text-xl text-gray-300 mb-8 max-w-lg mx-auto lg:mx-0"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7, delay: 0.3 }}
              >
                Unlock the full potential of your customer data with our cutting-edge analytics platform. Make data-driven decisions with confidence.
              </motion.p>

              <motion.div
                className="flex flex-col sm:flex-row justify-center lg:justify-start items-center gap-4"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.5 }}
              >
                <motion.button
                  onClick={() => window.location.href = 'https://oyster-lite.us.auth0.com/u/signup?state=hKFo2SBYUEFSNUNhaEYwSDRneGtWbXZEQ2tzN0lpUlAzMV81RqFur3VuaXZlcnNhbC1sb2dpbqN0aWTZIGZaamZtT2EtemZlNTg3a1lVWEs0em9sb1hwcUJhNi1Eo2NpZNkgUVlzcURQeERjTmhxbk5hdkJHTTlFZ215VnRqUkZwa3k'}
                  className="w-full sm:w-auto px-8 py-3 bg-red-600 text-white font-medium rounded-md shadow-lg hover:bg-red-700 transition-all duration-300"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Get Started
                </motion.button>
              </motion.div>
            </motion.div>
          </div>

          {/* Right dashboard */}
          <div className="w-full lg:w-1/2 relative">
            <motion.div
              className="relative z-0"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9, delay: 0.2 }}
            >
              <AnalyticsDashboard />
            </motion.div>
          </div>
        </div>
      </div>

      {/* Brands section */}
      {/* <div className="container mx-auto px-4 mt-20 bg-secondary py-20 ">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.8 }}
        >
          <p className="text-sm uppercase font-medium text-gray-500 tracking-wider mb-6">Trusted by industry leaders</p>
          <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8">
            {[
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/11/dermalogica.png", alt: "Dermalogica" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/11/igram.png", alt: "Igram" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/11/solar-turbines-1.png", alt: "Solar Turbines" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/11/lamps-plus.png", alt: "Lamps Plus" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/11/sempra-1.png", alt: "Sempra" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/11/informatica.png", alt: "Informatica" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/11/walmart-1.png", alt: "Walmart" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/12/towerdata1.png", alt: "Towerdata" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/12/bbdex1.png", alt: "Bbdex" },
              { src: "https://d3caycb064h6u1.cloudfront.net/wp-content/uploads/2024/12/saas-1.png", alt: "Saas" }
            ].map((brand, index) => (
              <div key={index} className="grayscale hover:grayscale-0 transition-all duration-300">
                <img
                  decoding="async"
                  src={brand.src}
                  alt={brand.alt}
                  className="max-h-10 lg:max-h-12 object-contain mix-blend-multiply dark:mix-blend-screen opacity-80 dark:opacity-90"
                />
              </div>
            ))}
          </div>
        </motion.div>
      </div> */}

      {/* Video Popup Modal */}
      <AnimatePresence>
        {showVideo && (
          <motion.div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowVideo(false)}
          >
            <motion.div
              className="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-4 right-4 z-10 bg-black/50 text-white rounded-full w-10 h-10 flex items-center justify-center"
                onClick={() => setShowVideo(false)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              {/* 9LtN7gQA22c */}
              <div className="relative aspect-video">
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src="https://www.youtube.com/embed/Qo8nCvUBkp8?autoplay=1"
                  title="Demo Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default HeroSection;
